import React                    from 'react';
import noLogoImage              from '../../lib/images/logo-restaurant-placeholder.svg';
import connect                  from 'react-redux/es/connect/connect';
import { bindActionCreators }   from 'redux';
import { getRestaurantDetails } from '../../store/actions/restaurant';

class RestaurantBanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = { details: null };
    }

    componentDidMount() {
        this.props.onLoad();
    }

    render() {
        const { details } = this.props.restaurant;

        return <div className="pc-restaurant-info">
            <div className="pc-restaurant-info__logo">
                {details && <img src={details.LogoUrl} onError={e => e.target.src = noLogoImage} width="70" alt="Logo" />}
                {!details && <img src={noLogoImage} width="70" alt="Logo" />}
            </div>
            <div className="pc-restaurant-info__description">
                <h3>
                    {details ? details.Name : <React.Fragment>&nbsp;</React.Fragment>}
                    {this.props.restaurant.isLoading &&
                    <div className="pc-loader pc-loader--large pc-loader--grey spinner--rotate"/>}
                </h3>
                <span>
                    {details && <React.Fragment>{details.Address.City}, {details.Address.Postcode} <br/></React.Fragment>}
                    Restaurant ID: {this.props.restaurant.restaurantId}
                </span>
            </div>
        </div>;
    }
}

export default connect(
    // State
    state => ({
        restaurant: state.restaurant
    }),

    // Actions
    dispatch => bindActionCreators({
        onLoad: getRestaurantDetails
    }, dispatch)
)(RestaurantBanner);



// WEBPACK FOOTER //
// /src/components/Header/RestaurantBanner.js